import React from 'react';
import { connect } from 'react-redux';

import { screen } from '../../../components/hoc';

import CommonScreen from './common';
import CurrentStateModel from '$fbusiness/models/currentState';

interface ReceivingScreenProps {
  currentState: CurrentStateModel;
}

const ReceivingScreen: React.FC<ReceivingScreenProps> = ({ currentState }) => {
  return (
    <CommonScreen
      isReceiving
      currentState={currentState}
      defaultFilter={{
        query: '',
        tableTabIndex: 0,
        confirmedAt: true,
        storeFlag: 1,
        received: 0,
        forceRefresh: false,
      }}
    />
  );
};

const mapStateToProps = state => ({
  resetOnRoute: true,
});

const connected = connect(mapStateToProps, null);

export default connected(screen(ReceivingScreen));
